import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PrivacyPolicyContent from './PrivacyPolicyContent';
import './LegalPage.css';

/**
 * Rechtsseiten für die App: /impressum, /datenschutz, /agb, /avv (+ englische Aliase).
 *
 * AGB, AVV und Impressum-Volltexte liegen auf www.bonusclub.io; hier steht nur die
 * Anbieterkennzeichnung (§ 5 DDG) plus Links. Ausnahme ist die Datenschutzerklärung:
 * Google verlangt für den OAuth-Zustimmungsbildschirm eine vollständige Fassung auf
 * der App-Domain. Sie muss mit www.bonusclub.io/privacy wortgleich bleiben.
 */

const PROVIDER = {
  name: 'BonusClub LLC',
  street: '7901 4th St N STE 300',
  city: 'St. Petersburg, FL 33702, USA',
  representedBy: 'Julian Propst, Geschäftsführender Gesellschafter (Managing Member)',
  registration: 'Eingetragen beim Florida Department of State, Division of Corporations',
  email: 'julian@bonusclub.io',
};

const BASE = 'https://www.bonusclub.io';

const DOCUMENTS = {
  imprint: {
    title: 'Impressum',
    intro: 'Angaben gemäß § 5 DDG (vormals § 5 TMG).',
    links: [
      { label: 'Impressum (deutsch)', href: `${BASE}/de/imprint` },
      { label: 'Legal Notice (English)', href: `${BASE}/imprint` },
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    Content: PrivacyPolicyContent,
  },
  terms: {
    title: 'Allgemeine Geschäftsbedingungen',
    intro:
      'Die AGB regeln die Nutzung der Plattform, insbesondere die Verantwortlichkeit für den Versand: Wer über die Plattform Nachrichten verschickt, ist datenschutzrechtlich Verantwortlicher für Empfängerauswahl, Inhalte und Frequenz.',
    links: [
      { label: 'AGB (deutsch)', href: `${BASE}/de/terms` },
      { label: 'Terms of Service (English)', href: `${BASE}/terms` },
    ],
  },
  dpa: {
    title: 'Auftragsverarbeitungsvertrag',
    intro:
      'Für die Verarbeitung personenbezogener Daten im Auftrag unserer Kunden gilt der Auftragsverarbeitungsvertrag nach Art. 28 DSGVO. Er wird mit Vertragsschluss Bestandteil des Vertrages.',
    links: [{ label: 'Auftragsverarbeitungsvertrag (AVV/DPA)', href: `${BASE}/dpa` }],
  },
};

const NAV = [
  { to: '/impressum', alias: '/imprint', label: 'Impressum' },
  { to: '/datenschutz', alias: '/privacy', label: 'Datenschutz' },
  { to: '/agb', alias: '/terms', label: 'AGB' },
  { to: '/avv', alias: '/dpa', label: 'AVV' },
];

const LegalPage = ({ document = 'imprint' }) => {
  const doc = DOCUMENTS[document] || DOCUMENTS.imprint;
  const { pathname } = useLocation();

  return (
    <div className="legal-page">
      <div className="legal-card">
        <nav className="legal-nav" aria-label="Rechtliches">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`legal-nav-link ${pathname === item.to || pathname === item.alias ? 'is-active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <h1 className="legal-title">{doc.title}</h1>

        {doc.Content ? (
          <doc.Content />
        ) : (
        <>
        <p className="legal-intro">{doc.intro}</p>

        <section className="legal-provider">
          <h2 className="legal-subtitle">Anbieter</h2>
          <address className="legal-address">
            <strong>{PROVIDER.name}</strong>
            <br />
            {PROVIDER.street}
            <br />
            {PROVIDER.city}
          </address>
          <dl className="legal-facts">
            <dt>Vertreten durch</dt>
            <dd>{PROVIDER.representedBy}</dd>
            <dt>Registrierung</dt>
            <dd>{PROVIDER.registration}</dd>
            <dt>Kontakt</dt>
            <dd>
              <a href={`mailto:${PROVIDER.email}`}>{PROVIDER.email}</a>
            </dd>
          </dl>
        </section>

        <section className="legal-docs">
          <h2 className="legal-subtitle">Vollständige Fassung</h2>
          <div className="legal-links">
            {doc.links.map((link) => (
              <a
                key={link.href}
                className="legal-link-button"
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
                <span aria-hidden="true">↗</span>
              </a>
            ))}
          </div>
          <p className="legal-note">
            Maßgeblich ist die jeweils unter bonusclub.io veröffentlichte Fassung.
          </p>
        </section>
        </>
        )}
      </div>
    </div>
  );
};

export default LegalPage;
